import http from '@/http-common'

const readjustmentTaxGetAll = async () => {
  return await http
    .get('/settings/readjustment-tax')
    .then(r => r.data)
    .catch(error => {
      throw error.response?.data || error.response || error
    })
}

const omieCategoriesGetAll = async () => {
  return await http
    .get('/settings/categories/omie')
    .then(r => r.data)
    .catch(error => {
      throw error.response?.data || error.response || error
    })
}

const getCategories = async () => {
  return await http
    .get('/settings/categories')
    .then(r => r.data)
    .catch(error => {
      throw error.response?.data || error.response || error
    })
}

const setCategories = async (data) => {
  return await http
    .post('/settings/categories', data)
    .then(r => r.data)
    .catch(error => {
      throw error.response?.data || error.response || error
    })
}

const omieBanksGetAll = async () => {
  return await http
    .get('/settings/banks')
    .then(r => r.data)
    .catch(error => {
      throw error.response?.data || error.response || error
    })
}

export default {
  readjustmentTax: {
    getAll: readjustmentTaxGetAll,
  },
  categories: {
    getAll: getCategories,
    omie: omieCategoriesGetAll,
    set: setCategories,
  },
  banks: {
    getAll: omieBanksGetAll,
  },
}
